module.exports = __webpack_public_path__ + "img/DTYLX_en.db688fe5.png";